import { Component, OnInit, TemplateRef } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { ToasterService } from '../services/toaster.service';
import { CommonService } from '../services/common.service';
import { PlatformLocation } from '@angular/common';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.css'],
  providers: [ToasterService,CommonService]
})
export class WalletComponent implements OnInit {
  modalRef: BsModalRef;
  redeemSuccess: boolean = false;
  userId:any;
  redeemAmount: any;
  loading: boolean;
  private onDestroy$: Subject<void> = new Subject<void>();
  referralData: any =  {
    passbook_data : []
  };
  constructor(private router: Router, 
    private serviceURLService: serviceURLService, 
    private modalService: BsModalService, 
    public toasterService: ToasterService, 
    public commonService : CommonService, 
    private platformLocation: PlatformLocation) {
   
   }

  ngOnInit() {
    this.userId = localStorage.getItem("userID");
    this.getWalletHisotry();
  }


  openModal(template: TemplateRef<any>) {
    this.redeemSuccess = false;
    this.modalRef = this.modalService.show(template, { class: 'modal-lg modal-dialog-centered', ignoreBackdropClick: false });
  }
  

  getWalletHisotry() {
    this.loading = true;
    this.serviceURLService.getWalletHistory(this.userId).pipe(takeUntil(this.onDestroy$)).subscribe((success: any) => {
      this.referralData = success.response;
      this.redeemAmount = this.convertRedeemAmount(this.referralData.Balance);
      this.loading = false;
    },error => {
      this.loading = false;
    })
  }

  redeemWalletPoints() {
    this.loading = true;
    let data = {
      "amount": this.redeemAmount
    }
    this.serviceURLService.redeemWalletPoints(this.userId, data).pipe(takeUntil(this.onDestroy$)).subscribe((success: any) => {
      this.referralData.Balance = success.response.Balance
      this.getWalletHisotry();
      this.redeemSuccess = true;
      this.loading = false;
    },error => {
      document.getElementById('errorMessage').innerText = error.error.message;
      this.loading = false;
    })
    
  }

  // convert the value for redeem with 500 gap
  convertRedeemAmount (value) {
    var returnvalue = value/500;
    return Math.floor(returnvalue)*500;
  }
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }


}
